import { render, staticRenderFns } from "./noaccess.vue?vue&type=template&id=d3abe06a&scoped=true&"
import script from "./noaccess.vue?vue&type=script&lang=js&"
export * from "./noaccess.vue?vue&type=script&lang=js&"
import style0 from "./noaccess.vue?vue&type=style&index=0&id=d3abe06a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3abe06a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
